import styled from "styled-components"

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${props => props.theme.colors.dark3};
  margin-top: 1rem;
`